<template>
  <StackItemModal
      :dialog="{}"
      :sheet="{}"
      breakpoint="md"
      :actions="actions"
      :actionClose="true"
      v-bind="stackComponent.bind"
      title="Изменить состав"
  >
    <q-list bordered separator>
      <q-item
          clickable
          v-ripple
          v-for="item in ingredientsComputed"
          :key="item.ELEMENT_ID"
          class="c-item"
          :class="{
            '--removed': removedItems.includes(item.ELEMENT_ID)
          }"
          @click="itemToggle(item)"
      >
        <q-item-section>
          <span class="c-name">{{ item.PRODUCT.NAME }}</span>
        </q-item-section>
        <q-item-section side>
          <q-toggle
              @update:model-value="itemToggle(item)"
              :model-value="!removedItems.includes(item.ELEMENT_ID)"
              color="primary"
          />
        </q-item-section>
      </q-item>
    </q-list>
  </StackItemModal>
</template>
<script setup lang="ts">
import {useStackComponent} from "@/packages/stack-router/hooks/useStackComponent";
import {computed, toRefs} from "vue";
import {Ingredient, MenuItem} from "@/gql/gen";
import {storeToRefs} from "pinia";

import {useCatalogStore} from "@/modules/shop/store/catalog";
import {ProductModel} from "@/modules/shop/composable/useProduct";
import {BasketItemModel} from "@/modules/shop/composable/util";

const catalogStore = useCatalogStore()
const {productIngredientsById} = storeToRefs(catalogStore)

const props = withDefaults(defineProps<{
  product: ProductModel,
  basketItem: BasketItemModel
}>(), {})

const stackComponent = useStackComponent(props)

const {stackItem} = stackComponent

const {basketItem, product} = toRefs(props)

const ingredientsComputed = computed(() => {
  return product.value.INGREDIENTS.map((item) => ({
    ...item,
    PRODUCT: productIngredientsById.value[item.ELEMENT_ID]
  })).filter(item => !!item.PRODUCT && item.IS_REMOVABLE)
})

const actions = computed<Partial<MenuItem>[]>(() => {
  return []
})

const removedItems = computed(() => basketItem.value.fields.PROPERTIES.INGREDIENTS_REMOVED)

const itemToggle = (item: Ingredient) => {
  basketItem.value.setIngredientState(item.ELEMENT_ID)
}


</script>
<style lang="scss" scoped>

.c-item {
  &.--removed {
    .c-name {
      text-decoration: line-through;
    }
  }
}
</style>
